
export default function Auth145Layout( { children } : { children: React.ReactNode } ) {
    return (
      <>
        {children}
      </>
    );
}